import {
  initCurrentSearchConditionItem
} from "./chunk-4RNAY45Z.mjs";

// lib/components/search-panel/search-condition-panel/hooks/storage/favorites-storage.ts
var loadFavorites = (key, items) => {
  return syncStorage(
    key,
    deserialize(localStorage.getItem(key) || void 0),
    items
  );
};
var saveFavorites = (key, favorites) => {
  localStorage.setItem(key, JSON.stringify(favorites));
};
var syncStorage = (key, favorites, items) => {
  let isChanged = false;
  const newItems = favorites.items.map((v) => ({
    ...v,
    inputs: v.inputs.filter((vv) => {
      const temp = items.some((item) => item.name === vv.name);
      if (!temp) isChanged = true;
      return temp;
    }).map((vv) => {
      const item = items.find((item2) => item2.name === vv.name);
      if (!item) return vv;
      if (vv.type !== item.type) {
        isChanged = true;
        return initCurrentSearchConditionItem(item);
      }
      if (vv.type === "select" && item.type === "select") {
        const hasOption = item.options.some((vvv) => vv.value === vvv.value);
        if (!hasOption) {
          isChanged = true;
          return initCurrentSearchConditionItem(item);
        }
      }
      if (vv.type === "multi-select" && item.type === "multi-select") {
        const same = vv.value.every(
          (val) => item.options.some((vvv) => val === vvv.value)
        );
        if (!same) {
          isChanged = true;
          const newValues = vv.value.filter(
            (val) => item.options.some((vvv) => val === vvv.value)
          );
          if (newValues.length === 0) {
            return initCurrentSearchConditionItem(item);
          }
          return { ...item, value: newValues };
        }
      }
      return vv;
    })
  }));
  const result = { ...favorites, items: newItems };
  if (isChanged) saveFavorites(key, result);
  return result;
};
var deserialize = (text) => {
  if (!text) return { items: [] };
  const temp = JSON.parse(text);
  return {
    ...temp,
    items: temp.items.map((v) => ({
      ...v,
      inputs: v.inputs.map((vv) => {
        if (vv.type !== "term") return vv;
        return {
          ...vv,
          value: vv.value.map((vvv) => vvv ? new Date(vvv) : void 0)
        };
      })
    }))
  };
};

export {
  loadFavorites,
  saveFavorites
};
